import React from 'react';
import { wrapReactionHook } from "../../hooks";
export var CityGroupSelect = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "CityGroupSelect", children);
});